import { createSelector } from "@ngrx/store";
import { AppState } from "../../app.state";

export const selectEntradaState = (state: AppState) => state.entradas.entradas;

export const selectEntradas = createSelector(
  selectEntradaState,
  (state) => state
);
